module.exports = __webpack_public_path__ + "static/media/v13.6fb67d76.mp4";